import React, { useState, useEffect } from "react";
import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { http } from "../../services/http";

const PlanosEditor = ({ value, onValueChange, disabled }) => {
  const [options, setOptions] = useState([]);

  function getPlanos() {
    http.get("planos").then((response) => {
      setOptions(response?.data);
    });
  }

  useEffect(() => {
    getPlanos();
  }, []);

  if (disabled) {
    return value;
  }

  return (
    <Select input={<Input />} value={value} onChange={(event) => onValueChange(event.target.value)} style={{ width: "95%" }}>
      <MenuItem value="">Todos</MenuItem>
      {options?.map((item) => {
        return (
          <MenuItem key={item.plano} value={item.plano}>
            {item.plano ?? item.plano}
          </MenuItem>
        );
      })}
    </Select>
  );
};
export const PlanosTypeProvider = (props) => <DataTypeProvider editorComponent={PlanosEditor} {...props} />;
